export default "__VITE_ASSET__BEW9WfSP__"